const NoSuccessErrorHandler = {
    onSuccess: () => { },
    onError: () => { }
};
var API_REQUEST_TYPE;
(function (API_REQUEST_TYPE) {
    API_REQUEST_TYPE[API_REQUEST_TYPE["DATABASE"] = 0] = "DATABASE";
    API_REQUEST_TYPE[API_REQUEST_TYPE["ELASTIC_SEARCH"] = 1] = "ELASTIC_SEARCH";
})(API_REQUEST_TYPE || (API_REQUEST_TYPE = {}));
var ApiKeyFilter;
(function (ApiKeyFilter) {
    ApiKeyFilter[ApiKeyFilter["ALL"] = 0] = "ALL";
    ApiKeyFilter[ApiKeyFilter["TRUE"] = 1] = "TRUE";
    ApiKeyFilter[ApiKeyFilter["FALSE"] = 2] = "FALSE";
})(ApiKeyFilter || (ApiKeyFilter = {}));
const ApiKeyFilterToBooleanMap = {
    [ApiKeyFilter.ALL]: undefined,
    [ApiKeyFilter.TRUE]: true,
    [ApiKeyFilter.FALSE]: false
};

export { API_REQUEST_TYPE, ApiKeyFilter, ApiKeyFilterToBooleanMap, NoSuccessErrorHandler };
//# sourceMappingURL=api.js.map
